<if(input.config)>
    <div class="str-follow-button">
        <!--
        activeSync=true keeps the state of the icon aligned with
        other instances of follow-ebay components on the page.
        -->
        <follow-ebay
            pointer="top-right"
            activeSync=true
            errorShow=true isLarge=true showToolTip=true
            config=input.config />
    </div>
</if>
